// extracted by mini-css-extract-plugin
module.exports = {"table":"jgp-253iy"};